var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaysIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0646A4EA-E6D6-4902-8E24-45B6930EC47B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_03",
    transform: "translate(-287.000000, -613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy-9",
    transform: "translate(260.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(20.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Rank",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4992588,10.6265489 L16.4992588,15.9511604 C16.4992588,16.2137081 16.2830508,16.4261593 16.0158604,16.4261593 L16.0158604,16.4261593 L3.41527441,16.4261593 C3.14808398,16.4261593 2.93187598,16.2137081 2.93187598,15.9511604 L2.93187598,15.9511604 L2.93187598,14.5261635 L13.1154697,14.5261635 C13.4539453,14.5261635 13.7834297,14.4092504 14.045915,14.1944876 C14.2667314,14.0128797 15.5672666,12.8733255 16.4992588,10.6265489 L16.4992588,10.6265489 Z M16.4830811,5.97615085 C16.3143105,11.0266563 13.5464678,13.3663428 13.4251348,13.4661875 C13.3382842,13.5371841 13.2287783,13.576134 13.1154697,13.576134 L13.1154697,13.576134 L0.482657227,13.576134 C0.279662109,13.576134 0.0988388672,13.4508926 0.0294550781,13.2639647 C-0.0404121094,13.0765617 0.0167255859,12.8659472 0.172025391,12.7370008 C0.198515625,12.7154992 2.74757227,10.5606507 2.91569824,5.97615085 L2.91569824,5.97615085 Z M13.1154375,2.1761593 C13.3861406,2.1761593 13.5988359,2.38515883 13.5988359,2.65115824 L13.5988359,2.65115824 L13.5988359,3.12615719 L16.0158281,3.12615719 C16.2865312,3.12615719 16.4992266,3.33515672 16.4992266,3.60115613 L16.4992266,3.60115613 L16.4992266,5.02615297 L2.93184375,5.02615297 L2.93184375,3.60115613 C2.93184375,3.33515672 3.14453906,3.12615719 3.41524219,3.12615719 L3.41524219,3.12615719 L5.83223437,3.12615719 L5.83223437,2.65115824 C5.83223437,2.38515883 6.04492969,2.1761593 6.31563281,2.1761593 C6.58633594,2.1761593 6.79903125,2.38515883 6.79903125,2.65115824 L6.79903125,2.65115824 L6.79903125,3.12615719 L9.21602344,3.12615719 L9.21602344,2.65115824 C9.21602344,2.38515883 9.42871875,2.1761593 9.69942187,2.1761593 C9.970125,2.1761593 10.1828203,2.38515883 10.1828203,2.65115824 L10.1828203,2.65115824 L10.1828203,3.12615719 L12.6320391,3.12615719 L12.6320391,2.65115824 C12.6320391,2.38515883 12.8447344,2.1761593 13.1154375,2.1761593 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysIcon);
export default __webpack_public_path__ + "static/media/DaysIcon.da40a347ede0b6091249763be01b86e7.svg";
export { ForwardRef as ReactComponent };